import { SerializableObject } from './serializable-object';

/** A simple raw text response domain object. */
export class TextResponse extends SerializableObject {
	text: string = '';
	
	public override buildFromJSON(json: string | { text: string }) {
		super.buildFromJSON(json);
		if (typeof json === 'string') {
			this.text = json;
		} else if (json && json.text) {
			this.text = json.text;
		} else {
			this.text = String(json);
		}
	}
}